import { FilterFields } from "api";
import { useEffect, useState } from "react";

interface FieldOperations {
    name: string;
    value: string;
}

export const useFilterOperationOptions = (fieldName: string, fields: FilterFields[]) => {
    const [fieldOperationOptions, setFieldOperationOptions] = useState<FieldOperations[]>([{ name: "", value: "" }]);

    useEffect(() => {
        const matchedOperations = fields.find(({ field }) => field === fieldName);

        if (matchedOperations) {
            const operationOptions = matchedOperations.operations.map(({ name, translation }) => {
                return {
                    name: translation,
                    value: name,
                };
            });

            setFieldOperationOptions(operationOptions);
        }
    }, [fieldName, fields]);

    return fieldOperationOptions;
};
